import { useUser } from "src/shared/context/UserContext";
import { fontColor, fontStyles, SlidbarThemeStyles, themeStyles } from "src/shared/services/themes";

type ThemeKey = keyof typeof themeStyles;
type SidebarThemeKey = keyof typeof SlidbarThemeStyles;
type FontKey = keyof typeof fontStyles;
type FontColorKey = keyof typeof fontColor;

export const ThemeBasedColorHeader = (): string => {
  const { user } = useUser();
  const key = (user?.themes.backgroundColour as ThemeKey) || "Blue";
  return themeStyles[key] || themeStyles["Blue"];
};

export const ThemeBasedColorMenubar = (): string => {
  const { user } = useUser();
  const key = (user?.themes.backgroundColour as SidebarThemeKey) || "Blue";
  return SlidbarThemeStyles[key] || SlidbarThemeStyles["Blue"];
};

export const ThemeFontStyle = (): string => {
  const { user } = useUser();
  const key = (user?.themes.fontFamily as FontKey) || "Serif";
  return fontStyles[key] || fontStyles["Serif"];
};

export const FontColor = (): string => {
  const { user } = useUser();
  const key = (user?.themes.backgroundColour as FontColorKey) || "Blue";
  return fontColor[key] || fontColor["Blue"];
};

export const OverallBg = (): string => {
  const { user } = useUser();
  return user?.themes.backgroundColour === "Light" ? "bg-gray-200" : "bg-white";
};
